// Editable placeholders for the Novare Estates desk.
export const SITE = {
  firm: "NOVARE ESTATES",
  tagline: "ODISHA · LAND & LEGACY",
  founders: "Aditya Narayan Garnaik & Vikram Singh Chouhan",
  city: "Bhubaneswar, Odisha",
  whatsappNumber: process.env.REACT_APP_WHATSAPP_NUMBER, // desk number — set in frontend/.env
  stats: [
    { label: "Under mandate", value: "₹1,200 Cr+" },
    { label: "Assets transacted", value: "47" },
    { label: "Cities covered", value: "12" },
    { label: "AI conversations handled", value: "38,000+" },
  ],
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const openWhatsApp = (message) =>
  window.open(waLink(message), "_blank", "noopener,noreferrer");
